import { Injectable } from '@angular/core'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { expertGroupPortalContent } from '../expert-group-portal.content'

@Injectable({
  providedIn: 'root'
})
export class ExpertGroupPortalService {
  getExpertGroupPortalById(expertGroupPortalId: string): ExpertGroupPortal {
    return expertGroupPortalContent.find(
      (group) => group.id === expertGroupPortalId
    )
  }
}
